import { FormProvider } from 'react-hook-form';

import Layout from '@/components/template/Layout';
import CourseStudioBreadcrumb from './CourseStudioBreadcrumb';
import CourseStudioService from './CourseStudioService';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { LoadingIcon } from '@/components/icons';
import HideForMobile from '@/components/ui/custom/HideForMobile';
import { useCourseStudio } from './CourseStudio.hooks';

export default function CourseStudio() {
  const {
    loading,
    loadingCoursePath,
    studioPermissions,
    form,
    defaultValues,
    resetForm,
  } = useCourseStudio();

  return (
    <HideForMobile>
      <Layout>
        <FormProvider {...form}>
          <main className="flex flex-col gap-4 h-full">
            <CourseStudioBreadcrumb
              courseName={defaultValues.course?.name}
              loading={loadingCoursePath}
            />

            <ConditionalRenderer
              condition={loading}
              fallback={
                <CourseStudioService
                  defaultValues={defaultValues}
                  studioPermissions={studioPermissions}
                  resetForm={resetForm}
                />
              }
            >
              <LoadingIcon className="w-10 h-10 text-primary self-center" />
            </ConditionalRenderer>
          </main>
        </FormProvider>
      </Layout>
    </HideForMobile>
  );
}
